<template>
	<div class="flex m-auto items-center justify-between mb-1">
		<div class="flex-grow flex flex-col items-start">
			<div :class="style.title">
				<span v-if="store.cart?.certificate?.code">Certificate: ({{ store.cart?.certificate?.code }})</span>
				<span v-else>Certificate:</span>
			</div>
			<div v-if="store.cart?.certificate?.code" class="flex justify-between">
				<button @click="removeCertificate" class="underline text-ihh-dark-salmon hover:text-ihh-salmon" :class="style.remove">Remove</button>
			</div>
		</div>
		<!-- <div class="flex w-full border-b border-dotted flex-grow m-auto items-center border-ihh-gray mx-4"></div> -->
		<div>
			<button @click="addingCertificate = !addingCertificate" :class="certificateClasses">
				{{ certificateText }}
			</button>
		</div>
	</div>

	<div v-if="addingCertificate" class="flex justify-between items-center mt-4 space-x-2">
		<div class="w-full">
			<input type="text" v-model="certificateCode" @input="toUpperCase" class="w-full border border-ihh-gray rounded-lg px-4 py-1" placeholder="Add Certificate" />
		</div>
		<div>
			<button @click="applyCertificate" class="bg-ihh-dark-salmon px-4 py-1 text-sm font-ihh-bold text-ihh-midnight-gray rounded-xl w-32">Apply</button>
		</div>
	</div>
</template>

<script>
import Swal from 'sweetalert2'
import axios from 'axios'
import { useCheckoutStore } from '../../stores/store.js'

export default {
	name: 'Certificate',
	inject: ['store'],
	props: {
		style: {
			type: Object,
			default: {
				title: 'font-bold text-ihh-midnight-gray',
				remove: 'text-sm',
			},
		},
	},
	data() {
		return {
			checkout: useCheckoutStore(),
			addingCertificate: false,
			certificateCode: '',
		}
	},

	mounted() {
		this.certificateCode = this.store.cart?.certificate?.code || ''
	},

	methods: {
		toUpperCase() {
			// Force certificate code to uppercase
			this.certificateCode = this.certificateCode.toUpperCase()
		},
		async applyCertificate() {
			console.log('applyCertificate', this.certificateCode)

			const url = `${this.store.api}/controllers/bigCommerce/checkout/carts/gift_certificates/${this.certificateCode}`
			const response = await axios.get(url)

			if (!response?.data?.success) {
				return Swal.fire({
					icon: 'error',
					title: 'Invalid Certificate Code',
					text: 'The provided code does not match any valid gift certificate.',
				})
			}

			if (response?.data?.data?.balance <= 0) {
				return Swal.fire({
					icon: 'error',
					title: '🎁 Certificate Balance Empty',
					text: 'Looks like this gift certificate has no remaining balance. Please use a different one or contact support if you think this is a mistake.',
				})
			}

			if (response?.data?.data?.status !== 'active') {
				return Swal.fire({
					icon: 'error',
					title: '🎁 Certificate Not Active',
					text: `This gift certificate is in a(n) ${response?.data?.data?.status} state. Please use a different one or contact support if you think this is a mistake.`,
				})
			}

			this.store.cart.certificate = response?.data?.data
			this.checkout.saveCartToLocalStorage(this.store.cart)

			this.addingCertificate = false
			this.certificateCode = ''

			// add logic to update mongo cart without triggering mango updated hook
		},
		removeCertificate() {
			this.store.cart.certificate = { code: '' }
			this.addingCertificate = false
			this.certificateCode = ''
			this.checkout.saveCartToLocalStorage(this.store.cart)

			// add logic to update mongo cart without triggering mango updated hook
		},
	},

	computed: {
		certificateText() {
			if (this.checkout.giftCertificateAmount) {
				return `-${this.checkout.giftCertificateAmount?.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}`
			} else {
				if (this.addingCertificate) return 'Cancel'
				return 'Gift Certificate'
			}
		},
		certificateClasses() {
			const baseClasses = 'w-28 text-right font-normal'
			if (this.checkout.giftCertificateAmount) return baseClasses
			if (this.addingCertificate) return 'underline cursor-pointer italic text-ihh-dark-salmon' + ' ' + baseClasses
			return 'underline cursor-pointer text-ihh-dark-salmon' + ' ' + baseClasses
		},
	},
}
</script>

<style scoped></style>
